import { ApiCardType } from '@/core/generated/api';
import type { SaveVoxServiceRequest, VoxServiceCardResponse } from '@/core/generated/api';
import type { VoxServiceValues } from './model/schema';

/** Подготавливает поля карточки услуги */
export const voxServiceToValues = (card?: VoxServiceCardResponse): VoxServiceValues => ({
    name: card?.name ?? '',
    description: card?.description ?? '',
    productId: card?.productId ?? '',
    backgroundColor: card?.backgroundColor ?? '#EEF5E9',
    cardType: card?.cardType === ApiCardType.Small
        ? ApiCardType.Small
        : ApiCardType.Big,
    imageUrl: card?.imageUrl ?? '',
    index: card?.index ?? 10,
    isShowServices: card?.isShowServices ?? false,
    isUnderDevelopment: card?.isUnderDevelopment ?? false,
});

/** Преобразует настройки в запрос сохранения */
export const voxServiceToRequest = (
    values: VoxServiceValues,
    version?: string
): SaveVoxServiceRequest => ({
    name: values.name.trim(),
    description: values.description || null,
    productId: values.productId,
    backgroundColor: values.backgroundColor.trim().toUpperCase(),
    cardType: values.cardType,
    imageUrl: values.imageUrl.trim() || null,
    index: values.index,
    isShowServices: values.isShowServices,
    isUnderDevelopment: values.isUnderDevelopment,
    version,
});

